import type { CarrierRate } from '../types'
import { useCheckoutContext } from '../index'

export const useCarrierRate = (): [
  ({ carrierRate, isManualShippingRate }: { carrierRate: CarrierRate; isManualShippingRate?: boolean }) => void,
] => {
  //it just a syntax sugar for shipping options carrier rate
  const checkoutContext = useCheckoutContext()
  const [, setData] = checkoutContext.shippingOptions

  const onSelect = ({
    carrierRate,
    isManualShippingRate = false,
  }: {
    carrierRate: CarrierRate
    isManualShippingRate?: boolean
  }) => {
    setData({
      carrierRate: {
        ...carrierRate,
        hasSelected: true,
      },
      shippingFee: carrierRate.shippingAmount,
      isManualShippingRate: isManualShippingRate,
    })
  }

  return [onSelect]
}
